import Model from 'flarum/Model';
import mixin from 'flarum/utils/mixin';

export default class HeroTagLatestdata extends mixin(Model, {
  tagId: Model.attribute('tagId'),
  mainImage: Model.attribute('mainImage'),
  mainTitle: Model.attribute('mainTitle'),
  storyImg: Model.attribute('storyImg'),
  storyContent: Model.attribute('storyContent'),
  heroTagHeroIntro: Model.hasMany('heroTagHeroIntro'),

}) {
  apiEndpoint() {
    return '/heroTagLatestdata' + (this.exists ? '/' + this.data.id : '');
  }
}
